import { TGetWebUsageSummaryReq } from "@sharedTypes/req.type";
import { TGetWebUsageSummaryRes } from "@sharedTypes/res.type";
import axios from "axios";

export async function GetWebUsageSummary() {
  const apiUrl = "/webusage/GetWebUsageSummary";

  const body: TGetWebUsageSummaryReq = {
    timeZone: new Date().getTimezoneOffset(),
  };

  const data: TGetWebUsageSummaryRes = await axios
    .post(apiUrl, body)
    .then((res) => res.data)
    .catch((err) => {
      console.log(err);
      throw err.response.data;
    });
  return data;
}
